<!-- Overrides @basecom-gmbh/pond/components/FrontendDetailPage.vue -->
<script setup lang="ts">
const { getProductRoute } = useProductRoute();
const { t } = useI18n();

const props = defineProps<{
    navigationId: string;
}>();

const { search } = useProductSearch();
const { getBreadcrumbs } = useCategoryBreadcrumbs();

// IDS-84 - add manufacturer media association
const { data: productResponse } = await useAsyncData('pdp' + props.navigationId, async () => {
    return await search(props.navigationId, {
        withCmsAssociations: true,
        criteria: {
            associations: {
                vendors: {
                    associations: {
                        shippingMethod: {},
                    },
                },
                options: {},
                deliveryTime: {},
                vendorsAvailableSalesChannels: {},
                properties: {
                    associations: {
                        group: {},
                        media: {},
                    },
                },
                manufacturer: {
                    associations: {
                        media: {},
                    },
                },
            },
        },
    });
});

if (!productResponse.value) {
    throw createError({ statusCode: 404, message: t('error.404.detail') });
}

const { product } = useProduct(productResponse.value.product, productResponse.value.configurator);

const breadcrumbs = await getBreadcrumbs(productResponse.value.product.seoCategory);
const { navigationContext } = useNavigationContext();

// add product as last breadcrumb entry on pdp
breadcrumbs.push({
    name: product.value.translated.name,
    path: `/${navigationContext.value?.seoPathInfo}` || getProductRoute(product.value),
});

useBreadcrumbs(breadcrumbs);
useAnalytics({ pageType: 'pdp', trackPageView: true });

// CUSTOM: Add SEO for product
useProductSeo(product);
</script>

<template>
    <CmsPage
        v-if="product?.cmsPage"
        :cms-page="product.cmsPage"
    />
</template>
